import { Box, Flex, Text, Icon, type BoxProps } from '@chakra-ui/react'
import React, { type ReactElement } from 'react'
import Wrap from './Wrap'

import { AiFillLinkedin } from '@react-icons/all-files/ai/AiFillLinkedin'
import { AiOutlineYoutube } from '@react-icons/all-files/ai/AiOutlineYoutube'
import { FaTwitch } from '@react-icons/all-files/fa/FaTwitch'
import { FaDiscord } from '@react-icons/all-files/fa/FaDiscord'
import { GiButterfly } from '@react-icons/all-files/gi/GiButterfly'

const Footer = ({ sx, ...rest }: BoxProps): ReactElement => {
  return (
    <Wrap
      as="footer"
      background="yellow.100"
      bottomHR={false}
      sx={{
        pb: '0px',
        'a:hover': {
          textDecor: 'underline'
        },
        p: {
          fontWeight: '500',
          fontSize: { base: '14px', lg: '16px' },
          lineHeight: '1.25',
          color: 'yellow.800'
        },
        svg: {
          mb: '-0.2em',
          fill: 'yellow.800'
        },
        ...sx
      }}
      {...rest}
    >
      <Box w="100%" p="20px">
        <Text variant="footer" textAlign="center">
          Copyright ©{new Date().getFullYear()} Reactvts |{' '}
          <Box as="a" href="/privacy">
            Privacy Policy
          </Box>{' '}
          |{' '}
          <Box
            as={'a'}
            role="button"
            cursor={'pointer'}
            onClick={() => {
              ; (window as any)?.CC?.showSettings()
            }}
          >
            Cookie Policy
          </Box>{' '}
          |{' '}
          <Box as="span" display="inline-block">
            <Flex as="span" gap="0.5em" px="0.25em">
              <Box
                as={'a'}
                title="Visit me on Bluesky"
                href="https://reactvts.bsky.social"
              >
                <Icon aria-label="Bluesky" boxSize="1.3em" as={GiButterfly} />
              </Box>
              <Box
                as={'a'}
                title="Visit me on Youtube"
                href="https://www.youtube.com/@reactvts"
              >
                <Icon
                  aria-label="Youtube"
                  boxSize="1.3em"
                  as={AiOutlineYoutube}
                />
              </Box>
              <Box
                as={'a'}
                title="Visit me on Twitch"
                href="https://www.twitch.tv/reactvts"
              >
                <Icon aria-label="Twitch" boxSize="1.0em" as={FaTwitch} />
              </Box>
              <Box
                as={'a'}
                title="Join our Discord"
                href="https://discord.gg/z2uZC4mFed"
              >
                <Icon aria-label="Twitch" boxSize="1.0em" as={FaDiscord} />
              </Box>
              <Box
                as={'a'}
                title="Visit me on LinkedIn"
                href="https://www.linkedin.com/company/reactvts"
              >
                <Icon
                  aria-label="LinkedIn"
                  boxSize="1.3em"
                  as={AiFillLinkedin}
                />
              </Box>
              {/* <Box
                as={'a'}
                title="Visit me on Kofi"
                href="https://ko-fi.com/U7U5RO3O9"
              >
                <Icon aria-label="Kofi" boxSize="1.3em" as={SiKoFi} />
              </Box> */}
            </Flex>
          </Box>
          <br />
          Made with Vite.js, React.js and{' '}
          <a
            href="https://ko-fi.com/U7U5RO3O9"
            target="_blank"
            rel="noreferrer"
          >
            ☕
          </a>{' '}
          by{' '}
          <Box
            as={'a'}
            title="Visit Seve's Linked In"
            href="https://www.linkedin.com/in/techsev/"
            target="_blank"
            rel="noreferrer"
          >
            Seve Savoie Teruel
            <Icon
              ml="0.25em"
              aria-label="Linked In"
              boxSize="1.3em"
              as={AiFillLinkedin}
            />
          </Box>
        </Text>
      </Box>
    </Wrap>
  )
}

export default Footer
